import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { AiCloseModalComponent } from './ai-close-modal.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [AiCloseModalComponent],
  exports: [AiCloseModalComponent],
})
export class AiCloseModalModule {}
